// todo
// resolution?

import {
	PointsMaterial,
	BufferGeometry,
	Points,
	Float32BufferAttribute
} from 'three';

import {
	to as convert,
	ColorSpace,
	P3,
	XYZ_D65
} from "./node_modules/colorjs.io/src/index-fn.js";

// slight perf improvement from providing these instead of strings
const p3 = ColorSpace.register(P3);
const xyz = ColorSpace.register(XYZ_D65);

import config from '/lib/config.js';

import initializeThreeScene from '/lib/initializeThreeScene.js';

import drawLabel from '/lib/drawLabel.js';
import drawXYZaxesAndLabels from '/lib/drawXYZaxesAndLabels.js';

// setup
const { scene, camera, renderer, controls } = initializeThreeScene(
	[2,2,2],
	[0.5,0.5,0.5]
);
document.getElementById('xyz-primaries').appendChild(renderer.domElement);


// coordinates

let p3ColorCoords = {
	black:   [ 0, 0, 0 ],
	red:     [ 1, 0, 0 ],
	lime:    [ 0, 1, 0 ], // css named color for all green...
	blue:    [ 0, 0, 1 ],
	yellow:  [ 1, 1, 0 ],
	cyan:    [ 0, 1, 1 ],
	magenta: [ 1, 0, 1 ], 
	white:   [ 1, 1, 1 ]
};

const xyzColorCoords = Object.keys( p3ColorCoords ).reduce( ( acc, colorName ) => {
	acc[ colorName ] = 
		convert( { space: p3, coords: p3ColorCoords[ colorName ] }, xyz ).coords;
	return acc;
}, {} );


const swatchScale = 0.1;
const redSwatch = drawLabel( './assets/swatch-red.svg', xyzColorCoords['red'], [swatchScale, swatchScale, swatchScale] );
scene.add(redSwatch);
const greenSwatch = drawLabel( './assets/swatch-green.svg', xyzColorCoords['lime'], [swatchScale, swatchScale, swatchScale] );
scene.add(greenSwatch);
const blueSwatch = drawLabel( './assets/swatch-blue.svg', xyzColorCoords['blue'], [swatchScale, swatchScale, swatchScale] );
scene.add(blueSwatch);


// points

// input: p3ColorCoords
// output: { 'red': Points, 'lime': Points, ...etc }
// const points = Object.keys( p3ColorCoords ).reduce( ( acc, nc ) => {
// 	const material = new PointsMaterial( { color: nc, sizeAttenuation: true, size: 0.2 } );
// 	const vertecies = convert( { space: p3, coords: p3ColorCoords[ nc ] }, xyz ).coords;
// 	const geometry = new BufferGeometry();
// 	geometry.setAttribute( 'position', new Float32BufferAttribute( vertecies, 3 ) );
// 	acc[nc] = new Points( geometry, material );
// 	return acc;
// }, {} );
// 
// Object.keys(points).forEach( name => scene.add(points[name]));



// axes and labels

const xzPlane = drawXYZaxesAndLabels( scene );



// render

let input = document.querySelector('input');

function animate() {
	requestAnimationFrame( animate );
	controls.update();
	
	renderer.render( scene, camera );
}
animate();